/* Shared only by the two results sections; no pricing math lives here. */
(function (root) {
  function normalizePriceUrl(value, defaultSort) {
    const url = new URL(value);
    let changed = false;
    for (const name of [...url.searchParams.keys()]) {
      if (name.startsWith('filter.v.price.')) {
        url.searchParams.delete(name);
        changed = true;
      }
    }
    if ((url.searchParams.get('sort_by') || '').startsWith('price-')) {
      url.searchParams.delete('sort_by');
      if (defaultSort) url.searchParams.set('sort_by', defaultSort);
      changed = true;
    }
    if (changed) {
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
    }
    return { url, changed };
  }

  // Native Shopify type filtering must happen before pagination and counts.
  function normalizeResultsUrl(value, defaultSort) {
    const normalized = normalizePriceUrl(value, defaultSort);
    const { url } = normalized;
    if (/\/search\/?$/.test(url.pathname) &&
        (url.searchParams.getAll('type').length !== 1 || url.searchParams.get('type') !== 'product,page')) {
      url.searchParams.set('type', 'product,page');
      url.searchParams.delete('page');
      url.searchParams.delete('section_id');
      normalized.changed = true;
    }
    if (/\/search\/?$/.test(url.pathname) && url.searchParams.get('options[unavailable_products]') !== 'last') {
      // Making Shopify's default explicit must not reset bookmarked pages.
      if (url.searchParams.has('options[unavailable_products]')) url.searchParams.delete('page');
      url.searchParams.set('options[unavailable_products]', 'last');
      url.searchParams.delete('section_id');
      normalized.changed = true;
    }
    return normalized;
  }

  class ResultsRequestGate {
    constructor() {
      this.generation = 0;
      this.timer = null;
      this.controller = null;
    }

    invalidate() {
      this.generation += 1;
      clearTimeout(this.timer);
      this.timer = null;
      this.controller?.abort();
      this.controller = null;
      return this.generation;
    }

    schedule(callback, delay = 800) {
      const generation = this.invalidate();
      this.timer = setTimeout(() => {
        this.timer = null;
        if (this.isCurrent(generation)) callback(generation);
      }, delay);
      return generation;
    }

    begin(generation) {
      if (!this.isCurrent(generation)) return null;
      this.controller = new AbortController();
      return this.controller.signal;
    }

    isCurrent(generation) {
      return generation === this.generation;
    }
  }

  const api = { normalizePriceUrl, normalizeResultsUrl, ResultsRequestGate };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root.document) {
    root.ArcticResults = api;
    const section = root.document.querySelector('[data-arctic-results]');
    const defaultSort = section?.dataset.resultsDefaultSort;
    const normalized = normalizeResultsUrl(root.location.href, defaultSort);
    if (section?.querySelector('[data-results-price-recovery]') && !normalized.url.searchParams.has('sort_by') && defaultSort) {
      normalized.url.searchParams.set('sort_by', defaultSort);
      normalized.url.searchParams.delete('page');
      normalized.changed = true;
    }
    if (normalized.changed) root.location.replace(normalized.url.href);
  }
})(globalThis);
